import ViewController from "./class.ViewController";

const caption = "Edit lesson settings.";

/**
 * A class which constructs the settings menu.
 */
export default class TransporterSettings extends ViewController {
	constructor(options) {
		super(options);

		// Create menu
		this.$settingsMenu = $(`<div class="settings-menu"></div>`)
			.appendTo(this.$el)
			.hide();

		// Create icon.
		this.$settingsIcon = $(
			`<div class="menu-icon settings-icon"><span class="aops-font">I</span></div>`
		)
			.attr("title", caption)
			.appendTo(this.$el)
			.click(() => {
				this.$settingsMenu.slideToggle(200);
			});

		this.loadSettingsFromStorage();
		this.buildSettingsMenuComponents();

		if (
			AoPS &&
			AoPS.Ecole &&
			AoPS.Ecole.Utils &&
			AoPS.Ecole.Utils.CreateTooltip
		) {
			AoPS.Ecole.Utils.CreateTooltip(this.$settingsIcon, caption);
		}
	}

	closeSettingsMenu() {
		this.$settingsMenu.slideUp(200);
	}

	loadSettingsFromStorage() {
		const storage = this.mainController.storageController;
		const messageDelay = storage.get("messageDelay");
		if (!_.isNull(messageDelay)) {
			try {
				const value = parseFloat(messageDelay);
				this.mainController.animationController.setMessageDelayModifier(
					parseFloat(messageDelay)
				);
				this.mainController.animationController.setDurationModifier(
					Math.min(value, 1)
				);
			} catch (e) {
				storage.remove("messageDelay");
			}
		}
	}

	/**
	 * Builds the components of the settings menu.
	 */
	buildSettingsMenuComponents() {
		const components = [];

		// Changes the animation speeds.
		// Subtracting from 2.1 as part of change to left to right speed slider. See big comment below
		let initialVal =
			2.1 -
			parseFloat(
				this.mainController.animationController.getMessageDelayModifier()
			);
		const $messageSpeed = $(`<div class="message-speed" />`);
		const $messageSpeedSlider = $(
			`<input type="range" min="0.1" max="2" class="slider" step="0.01">`
		)
			.val(initialVal)
			.change(() => {
				/**
				 * The higher the delay/duration value, the slower it gets
				 * Now that we want to make the speed slider go left to right,
				 * I will reverse the bar's effects by subtracting the .val from a max value of 2.1
				 * Subtracting from 2.1 retains the same old range of 0.1 to 2
				 */
				const value = 2.1 - parseFloat($messageSpeedSlider.val());
				this.mainController.storageController.set("messageDelay", value);
				this.mainController.animationController.setMessageDelayModifier(value);
				this.mainController.animationController.setDurationModifier(
					Math.min(value, 1)
				);
			});
		$messageSpeed
			.append($(`<span class="label">Message Speed</span>`))
			.append($messageSpeedSlider);
		components.push($messageSpeed);

		// Append all the components.
		_.each(components, (c) => {
			this.$settingsMenu.append(c);
		});
	}
}
